module.exports = __webpack_public_path__ + "static/media/sai-global-logo-charcoal.41de9a6b.svg";